import styled from 'styled-components';
import { ActionButton } from 'components/ui/Button';
import CurrencySelect from 'components/shared/CurrencySelect/CurrencySelect';

export const BackButton = styled(ActionButton)`
  display: inline-block;
`;

export const StyledCurrencySelect = styled(CurrencySelect)`
  margin: auto 0;
`;

export const StyledToggle = styled('a')`
  cursor: pointer;
  text-decoration: underline;
  padding-right: 8px;
  display: flex;
  align-items: center;
  white-space: nowrap;

  > svg {
    margin-right: 4px;
  }
`;
